import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

// actions
import actions from "../../store/actions";
import Spinner from "components/Spinner";
import { useGetWorkbooksQuery } from "store/services/workbook.service";
import ErrorComponent from "components/shared/ErrorComponent";
import { ChartLineIconLight } from "Assets/icons";

const Workbooks = () => {
  const { data, isLoading, isError } = useGetWorkbooksQuery({ limit: 10 });
  const workbooks = data?.items;

  return (
    <div className="contentBody px-2 workbook-list">
      {isLoading ? (
        <div className="d-flex justify-content-center pb-0 pt-2">
          <Spinner />
        </div>
      ): isError ? (
        <ErrorComponent />
      ): workbooks?.length ? (
        <ul className="list-unstyled ps-0 mb-0 pt-2 pb-1">
          {workbooks.map((item) => (
            <li key={item._id} className="py-2">
              <Link
                to={`/workbook/${item._id}`}
                className="d-flex align-items-start text-dark"
                reloadDocument
              >
                <ChartLineIconLight />
                <div className="content">
                  <h6 className="m-0 fw-sbold">{item.toolName}</h6>
                  <p className="text-muted m-0">
                    {moment(item.createdAt).format("DD-MMM-YY LT")}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ):(
        <p className="m-0 py-2 text-center text-body">You haven't uploaded any workbooks yet</p>
      )}
    </div>
  );
};

export default Workbooks;
